// extracted by mini-css-extract-plugin
export var container = "_7e-0";
export var fallback = "_7e-5";
export var fallbackIcon = "_7e-6";
export var hidden = "_7e-2";
export var image = "_7e-3";
export var loaded = "_7e-4";
export var placeholder = "_7e-1";